import React, {useEffect, useState} from "react";
import styled from "styled-components";
import useSquad from "../Provider/useSquad";
import {Colors} from "../Styles/Colors";
import {SquadTabs} from "./Squad/_SquadTabs";
import {HeaderTextDescription} from "./Squad/Sections/HeaderTextDescription";

export const Styles = {
	Frame: styled.div`
		padding: 20px;
		display: flex;
		flex-direction: column;
		gap: 14px;
	`,
	Panel: styled.div`
		display: flex;
		flex-direction: column;
		gap: 12px;
		padding: 16px;
		border: 1px solid ${Colors.raw.terminal_light};
		border-radius: 8px;
		background-color: rgba(255, 255, 255, 0.04);
		box-shadow:
			0 0 8px rgba(255, 255, 255, 0.15),
			0 0 16px ${Colors.raw.terminal_light};
	`,
	Title: styled.h2`
		margin: 0;
		font-size: 1.2rem;
		letter-spacing: 0.08em;
		text-transform: uppercase;
	`,
	Input: styled.input`
		border: 1px solid ${Colors.raw.terminal_light};
		border-radius: 6px;
		padding: 8px 10px;
		color: white;
		background-color: rgba(0, 0, 0, 0.35);
		outline: none;

		&:focus {
			box-shadow:
				0 0 8px rgba(255, 255, 255, 0.25),
				0 0 16px ${Colors.raw.terminal_light};
		}
	`,
	Button: styled.button`
		border: 1px solid ${Colors.raw.terminal_light};
		border-radius: 6px;
		padding: 8px 10px;
		color: white;
		background-color: rgba(255, 255, 255, 0.08);
		cursor: pointer;

		&:hover {
			background-color: rgba(255, 255, 255, 0.16);
			box-shadow: 0 0 12px ${Colors.raw.terminal_light};
		}

		&:disabled {
			opacity: 0.4;
			cursor: not-allowed;
		}
	`,
	CurrentInstance: styled.div`
		font-size: 0.8rem;
		color: rgba(255, 255, 255, 0.65);
		word-break: break-all;
	`,
	Actions: styled.div`
		display: flex;
		gap: 10px;
		flex-wrap: wrap;
	`,
};

export const Squad = () => {

	const { Actions, instanceId } = useSquad();

	const [instanceInput, setInstanceInput] = useState("");

	const handles = {
		createInstance: () => {
			Actions.instance.create();
		},
		joinInstance: () => {
			if( instanceInput )
				Actions.instance.join( instanceInput );
		},
	};

	if( ! instanceId )
		return (
			<Styles.Frame>
				<Styles.Panel>
					<Styles.Title>Squad-Instanz</Styles.Title>

					<Styles.Input
						value={ instanceInput }
						placeholder="Instanz-UUID eingeben"
						onChange={ event => setInstanceInput(event.target.value) }
						onKeyDown={ event => {
							if( event.key === "Enter" )
								handles.joinInstance();
						}}
					/>

					<Styles.Actions>
						<Styles.Button
							type="button"
							disabled={ !instanceInput.trim() }
							onClick={ handles.joinInstance }
						>
							Instanz beitreten
						</Styles.Button>

						<Styles.Button
							type="button"
							onClick={ handles.createInstance }
						>
							Neue Instanz erstellen
						</Styles.Button>
					</Styles.Actions>
				</Styles.Panel>
			</Styles.Frame>
		);

	return (
		<Styles.Frame>
			<HeaderTextDescription />
			<SquadTabs />
		</Styles.Frame>
	);
};